import SerpPluginBase, { ISerpPlugin } from '~/plugins/SerpPlugin';

class SerpPlugin extends SerpPluginBase implements ISerpPlugin {
    private _name = 'dramroom';

    constructor() {
        super();
        this.loadActions();
        this.loadFilters();
    }

    loadActions(): void {
        this.setActions({});
    }

    loadFilters(): void {
        this.setFilters({});
    }

    get name(): string {
        return this._name;
    }
}

export default SerpPlugin;
